const LOCALHOST_PORT = 9000;
const BASE_URL = `http://localhost:${LOCALHOST_PORT}`;
 
const IS_WEB_APP = true;
const IS_ELECTRON_APP = false; //"electron"

const IS_SERVER_DEPLOYED = true; // false if server is running on localhost

const SERVER_LOCALHOST_PORT = 4001;

const SERVER_BASE_URL = IS_SERVER_DEPLOYED
  ? `https://avc-collab.onrender.com`
  : `http://localhost:${SERVER_LOCALHOST_PORT}`;

const SOCKET_ENDPOINT = IS_SERVER_DEPLOYED
  ? `wss://avc-collab.onrender.com`
  : SERVER_BASE_URL + "/";

const DEFAULT_YT_VIDEO_ID = "8tPnX7OPo0Q";

const REACT_DEV = IS_WEB_APP; // false if we r going to run in electron

export {
  BASE_URL,
  REACT_DEV,
  SERVER_BASE_URL,
  SOCKET_ENDPOINT,
  DEFAULT_YT_VIDEO_ID,
  IS_ELECTRON_APP,
};
